// extracted by mini-css-extract-plugin
export default {"htmlContent":"ThemedDialog_htmlContent__2ynuN"};